import { baseURL } from 'app/api';
import { startEarlyRequests } from 'app/earlyRequests';

const INITIAL_MESSAGE_PAGE_SIZE = 200;

/** The first read a chat makes when it opens. */
export const initialMessagesPath = (clientWaNumber: string): string =>
  `/messages/${clientWaNumber}?limit=${INITIAL_MESSAGE_PAGE_SIZE}`;

/**
 * Start that read on the press, ahead of the click that opens the chat. Good
 * for 3 seconds: a press that never becomes a click is simply dropped.
 */
export const preloadChat = (clientWaNumber: string): void =>
  startEarlyRequests(baseURL, [initialMessagesPath(clientWaNumber)], 3000);
